// Shared helper for ordering a consumable batch's photos with its display
// (primary) photo first. Reused by the dashboard list and the details modal.

export interface BatchPhotoFields {
  photo_1_url: string | null;
  photo_2_url: string | null;
  photo_3_url: string | null;
  photo_4_url: string | null;
  photo_5_url: string | null;
  primary_photo_slot?: number | null;
}

export interface OrderedPhoto {
  /** 1-based photo slot number (matches photo_{slot}_url). */
  slot: number;
  url: string;
  isPrimary: boolean;
}

/** Occupied photos, display/primary photo first.
 * Primary = `primary_photo_slot` when it points at an occupied slot, else the
 * first occupied slot (backward-compatible with rows that predate the field). */
export function orderedBatchPhotos(b: BatchPhotoFields): OrderedPhoto[] {
  const occupied = [b.photo_1_url, b.photo_2_url, b.photo_3_url, b.photo_4_url, b.photo_5_url]
    .map((url, i) => ({ slot: i + 1, url }))
    .filter((p): p is { slot: number; url: string } => !!p.url);

  const primarySlot =
    b.primary_photo_slot && occupied.some(p => p.slot === b.primary_photo_slot)
      ? b.primary_photo_slot
      : occupied[0]?.slot ?? null;

  return occupied
    .map(p => ({ ...p, isPrimary: p.slot === primarySlot }))
    .sort((a, c) => (a.isPrimary === c.isPrimary ? a.slot - c.slot : a.isPrimary ? -1 : 1));
}
